// react
import { useTranslation } from 'react-i18next';

// types
import { Country } from '../../../@types';

// mui
import { Grid, Typography, TypographyProps } from '@mui/material';

// ui
import { Flag } from '../Flag/Flag';
import { flagsByCurrency } from '../../../utils/currency';

// props
export interface FlagTextProps {
	country?: Country | undefined;
	currency?: string;
	TypographyProps?: TypographyProps;
}

export const FlagText = ({ country, currency, TypographyProps }: FlagTextProps) => {
	// hooks
	const { t } = useTranslation();

	let code = undefined;
	if (country?.code) {
		code = country.code;
	} else if (currency) {
		code = flagsByCurrency[currency];
	}

	return (
		<Grid alignItems="center" container spacing={1} wrap="nowrap">
			{code && (
				<Grid item>
					<Flag code={code} />
				</Grid>
			)}
			<Grid item>
				<Typography {...TypographyProps}>{country?.name || currency || t('na')}</Typography>
			</Grid>
		</Grid>
	);
};
